function setupAllDualSliders(scope = document) {
  const containers = scope.querySelectorAll ? scope.querySelectorAll('.tram-price-sliders, .price-range__sliders') : [];
  containers.forEach((container) => {
    const inputs = container.querySelectorAll('input[type="range"]');
    if (inputs.length < 2) return;
    const minSlider = inputs[0];
    const maxSlider = inputs[1];

    let activeSlider = null;

    const updateSplit = () => {
      if (activeSlider) return; // Don't clip while active drag is in progress

      const minVal = Number(minSlider.value) || 0;
      const maxVal = Number(maxSlider.value) || 0;
      const minLimit = Number(minSlider.min) || 0;
      const maxLimit = Number(maxSlider.max) || 100;
      const range = maxLimit - minLimit || 1;

      const pctMin = Math.max(0, Math.min(100, ((minVal - minLimit) / range) * 100));
      const pctMax = Math.max(0, Math.min(100, ((maxVal - minLimit) / range) * 100));

      let splitPct = (pctMin + pctMax) / 2;
      if (splitPct < 1) splitPct = 1;
      if (splitPct > 99) splitPct = 99;

      // Clip minSlider so it only intercepts touches on the left of splitPct
      minSlider.style.clipPath = `inset(0 ${100 - splitPct}% 0 0)`;
      minSlider.style.webkitClipPath = `inset(0 ${100 - splitPct}% 0 0)`;
      minSlider.style.zIndex = '3';

      // Clip maxSlider so it only intercepts touches on the right of splitPct
      maxSlider.style.clipPath = `inset(0 0 0 ${splitPct}%)`;
      maxSlider.style.webkitClipPath = `inset(0 0 0 ${splitPct}%)`;
      maxSlider.style.zIndex = '2';
    };

    container.updateDualSplit = updateSplit;

    if (container.dataset.dualSliderReady === 'true') {
      updateSplit();
      return;
    }
    container.dataset.dualSliderReady = 'true';

    const startDrag = (slider) => {
      activeSlider = slider;
      minSlider.style.clipPath = 'none';
      minSlider.style.webkitClipPath = 'none';
      maxSlider.style.clipPath = 'none';
      maxSlider.style.webkitClipPath = 'none';

      if (slider === minSlider) {
        minSlider.style.zIndex = '10';
        maxSlider.style.zIndex = '1';
      } else {
        maxSlider.style.zIndex = '10';
        minSlider.style.zIndex = '1';
      }
    };

    const stopDrag = () => {
      if (!activeSlider) return;
      activeSlider = null;
      updateSplit();
    };

    minSlider.addEventListener('pointerdown', () => startDrag(minSlider));
    minSlider.addEventListener('touchstart', () => startDrag(minSlider), { passive: true });
    minSlider.addEventListener('mousedown', () => startDrag(minSlider));

    maxSlider.addEventListener('pointerdown', () => startDrag(maxSlider));
    maxSlider.addEventListener('touchstart', () => startDrag(maxSlider), { passive: true });
    maxSlider.addEventListener('mousedown', () => startDrag(maxSlider));

    window.addEventListener('pointerup', stopDrag);
    window.addEventListener('touchend', stopDrag, { passive: true });
    window.addEventListener('mouseup', stopDrag);

    minSlider.addEventListener('input', () => {
      if (Number(minSlider.value) > Number(maxSlider.value)) {
        minSlider.value = maxSlider.value;
      }
    });

    maxSlider.addEventListener('input', () => {
      if (Number(maxSlider.value) < Number(minSlider.value)) {
        maxSlider.value = minSlider.value;
      }
    });

    minSlider.addEventListener('change', updateSplit);
    maxSlider.addEventListener('change', updateSplit);

    updateSplit();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setupAllDualSliders());
} else {
  setupAllDualSliders();
}

document.addEventListener('on:facet-filters:updated', () => setupAllDualSliders());
document.addEventListener('click', (e) => {
  if (e.target && e.target.closest && e.target.closest('.js-drawer-open, [aria-controls="facets"], .products-toolbar__filter-btn, summary, details')) {
    setTimeout(setupAllDualSliders, 50);
  }
});

if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    connectedCallback() {
      setupAllDualSliders(this);
    }

    init() {
      this.minNumberInput = this.querySelector('#price-range-number-min') || document.getElementById('price-range-number-min');
      this.maxNumberInput = this.querySelector('#price-range-number-max') || document.getElementById('price-range-number-max');
      this.minSliderInput = this.querySelector('#price-range-slider-min') || document.getElementById('price-range-slider-min');
      this.maxSliderInput = this.querySelector('#price-range-slider-max') || document.getElementById('price-range-slider-max');
      this.minValue = Number(this.minNumberInput.min);
      this.maxValue = Number(this.maxNumberInput.max);
      this.timeout = null;
      this.addEventListener('input', this.handleInput.bind(this));
      setupAllDualSliders(this);
    }

    /**
     * Handles 'input' events on the price range component.
     * @param {object} evt - Event object.
     */
    handleInput(evt) {
      if (evt.detail !== undefined) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
          const container = this.querySelector('.tram-price-sliders, .price-range__sliders');
          if (container && container.updateDualSplit) container.updateDualSplit();
        }, 500);
      } else {
        this.updateSliderInputs(evt);
        this.updateNumberInputs();
        const container = this.querySelector('.tram-price-sliders, .price-range__sliders');
        if (container && container.updateDualSplit) container.updateDualSplit();
      }
    }

    /**
     * Updates the value of the 'number' type inputs.
     */
    updateNumberInputs() {
      this.minNumberInput.value = this.minSliderInput.value !== this.minNumberInput.min
        ? this.minSliderInput.value : null;

      this.maxNumberInput.value = this.maxSliderInput.value !== this.maxNumberInput.max
        ? this.maxSliderInput.value : null;
    }

    /**
     * Updates the value of the 'range' type inputs.
     * @param {object} evt - Event object.
     */
    updateSliderInputs(evt) {
      if (evt.target === this.minSliderInput) {
        if (Number(this.minSliderInput.value) > Number(this.maxSliderInput.value)) {
          this.minSliderInput.value = this.maxSliderInput.value;
        }
      }

      if (evt.target === this.maxSliderInput) {
        if (Number(this.maxSliderInput.value) < Number(this.minSliderInput.value)) {
          this.maxSliderInput.value = this.minSliderInput.value;
        }
      }

      const minValue = parseInt(this.minNumberInput.value, 10);
      const maxValue = parseInt(this.maxNumberInput.value, 10);

      if (minValue > maxValue - 10) {
        if (evt.target === this.minNumberInput) {
          this.maxSliderInput.value = minValue + 10;

          if (maxValue === this.maxValue) {
            this.minSliderInput.value = this.maxValue - 10;
          }
        } else if (evt.target !== this.minSliderInput && evt.target !== this.maxSliderInput) {
          this.minSliderInput.value = maxValue - 10;
        }
      }

      if (maxValue < minValue + 10) {
        if (evt.target === this.maxNumberInput) {
          this.minSliderInput.value = maxValue - 10;

          if (minValue === this.minValue) {
            this.maxSliderInput.value = 10;
          }
        } else if (evt.target !== this.minSliderInput && evt.target !== this.maxSliderInput) {
          this.maxSliderInput.value = minValue + 10;
        }
      }

      if (evt.target === this.minNumberInput) {
        this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
      }

      if (evt.target === this.maxNumberInput) {
        this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
      }
    }
  }

  customElements.define('price-range', PriceRange);
}
